import { RouteComponentProps } from 'react-router'
import { getStoreData } from '@utils/store'
import { getHttpsOrigin, isInWhiteList } from '@utils'
import qs from 'qs'
import { routeParams } from '@views/PracticeTrain/config'
export { lazyLoad } from './lazyLoad'

export class RouterUtil {
  public static newLink = (href: string, target?: '_blank' | '_self') => {
    const alink = document.getElementById(
      'hiddenLink'
    ) as HTMLAnchorElement | null
    if (alink) {
      alink.target = target || '_blank'
      alink.href = href
      alink.click()
    }
  }

  public static toCoursePlay = (
    history: RouteComponentProps['history'],
    id: string
  ) => {
    history.push(`/coursePlay/${id}`)
  }

  public static toHome = (history: RouteComponentProps['history']) =>
    history.push('/home/homePage')

  public static toAdmin = (pathName: string) => {
    const isDev = process.env.NODE_ENV === 'development'
    const isTarget = isInWhiteList(pathName)
    let prefix = `${isDev ? '' : '/znWeb/znPortal'}/#/admin/`

    if (isTarget) {
      prefix = isDev ? '/#/' : '/znWeb/znPortal/#/'
    }

    // TODO云校
    // let prefix = `${isDev ? '' : '/cloud-school/pc-web/znPortal'}/#/admin/`

    // if (isTarget) {
    //   prefix = isDev ? '/#/' : '/cloud-school/pc-web/znPortal/#/'
    // }
    const path = `${prefix}${pathName}`
    RouterUtil.newLink(path)
  }

  /** 跳转到搜索结果页面 */
  public static toSearchPage = (
    history: RouteComponentProps['history'],
    searchWord: string
  ) => history.push(`/home/search?searchWord=${searchWord}`)
  // 问卷
  public static toSelfQuestionnaire = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/myQuestionnaireDetail/${id}`)
  // 作业
  public static toSelfWork = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/myWorkDetail/${id}`)

  public static toSelfStudyMap = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/studyDetail/${id}`)

  // 考试详情页启用摄像头需要使用https
  public static toExam = (examId: string) => {
    const data = getStoreData()
    const origin = getHttpsOrigin()
    location.href = `${origin}/#/home/examDetail/${examId}?data=${data}`
  }
  // 培训班
  public static toSelfTrainingClass = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/myTrainingDetail/${id}`)

  public static toTrainingClass = (id: string) => {
    RouterUtil.newLink(`#/home/myTrainingDetail/${id}`)
  }
  public static toCourse = (id: string) => {
    RouterUtil.newLink(`#/home/courseDetail/${id}`)
  }

  public static toCourseList = (
    history: RouteComponentProps['history'],
    params = {} as {
      oneAttributeId?: string,
      oneAttributeName?: string,
      twoAttributeId?: string,
      twoAttributeName?: string,
      thirdAttributeId?: string,
      thirdAttributeName?: string,
      pageId?: string
    }
  ) => history.push(`/home/course?${qs.stringify(params)}`)
  // 课程详情
  public static toSelfCourse = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/courseDetail/${id}`)
  // 直播详情
  public static toLive = (
    id: string,
    type: 'playback' | 'live',
    column?: string
  ) => {
    RouterUtil.newLink(
      `#/liveroom/${id}/${(type === 'playback' && '2') || '1'}/${column || ''}`
    )
  }

  public static toTopicPost = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/postDetail/${id}`)

  public static toSelfLive = (
    history: RouteComponentProps['history'],
    id: string,
    type: 'playback' | 'live',
    title: string,
    params = {} as {
      secretValue?: string
      viewFrom?: string
    }
  ) => {
    history.push(
      `/liveroom/${id}/${(type === 'playback' && '2') || '1'}/${title ||
        ''}?${qs.stringify(params)}`
    )
  }

  public static toReplay = (id: string) => {
    // zn-i18n-disable-next-line
    RouterUtil.newLink(`#/liveroom/${id}/2/回放`)
  }

  public static toShortVideo = (
    history: RouteComponentProps['history'],
    shortVideoId: string,
    title: string,
    params = {} as {
      viewFrom?: string
    }
  ) =>
    history.push(
      `/litevideo/${shortVideoId}/0/16/0/${title || ''}?${qs.stringify(params)}`
    )

  public static toLiveRoom = (id: string) => {
    // zn-i18n-disable-next-line
    RouterUtil.newLink(`#/liveroom/${id}/1/直播`)
  }

  public static toInformation = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/information/${id}`)

  public static toSeminar = (
    history: RouteComponentProps['history'],
    seminarId: string
  ) => history.push(`/home/seminar/${seminarId}`)

  public static toCourseTopic = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/courseToptic/${id}`)

  public static toHomePage = (history: RouteComponentProps['history']) =>
    history.push('/home/homePage')

  public static toTalk = (
    history: RouteComponentProps['history'],
    id: string,
    idPracticalTraining: string,
    startTime: string,
    endTime: string,
    identityType: number,
    trainingName: string
  ) =>
    history.push(
      `/home/practiceTrain/faceRecord?id=${id}&idPracticalTraining=${idPracticalTraining}&startTime=${startTime}&endTime=${endTime}&identityType=${identityType}&trainingName=${trainingName}`
    )

  public static toTalkingDetail = (
    id: string,
    idPracticalTraining: string,
    yearMonth: string,
    identityType: string,
    monthlyNumber: number
  ) => {
    if (identityType === '0') {
      RouterUtil.toAdmin(
        `practice-train/student-facetalking-detail?id=${id}&idPracticalTraining=${idPracticalTraining}&yearMonth=${yearMonth}&identityType=${identityType}&monthlyNumber=${monthlyNumber}`
      )
    } else {
      RouterUtil.toAdmin(
        `practice-train/director-facetalking-detail?id=${id}&idPracticalTraining=${idPracticalTraining}&yearMonth=${yearMonth}&identityType=${identityType}&monthlyNumber=${monthlyNumber}`
      )
    }
  }

  public static toRegularSheet = (
    idMlnEmp: string,
    identityType: number,
    idPracticalTraining: string
  ) => {
    RouterUtil.toAdmin(
      `practice-train/regular-assess-sheet?idMlnEmp=${idMlnEmp}&idPracticalTraining=${idPracticalTraining}&identityType=${identityType}`
    )
  }

  public static toDirectorComment = (
    idMlnEmp: string,
    idPracticalTraining: string,
    surveyStatus: number
  ) => {
    RouterUtil.toAdmin(
      `practice-train/director-comment-sheet?idMlnEmp=${idMlnEmp}&idPracticalTraining=${idPracticalTraining}&surveyStatus=${surveyStatus}`
    )
  }

  // 跳转主管评价表 （前测）
  public static toSupervisorSheet = () => {
    RouterUtil.toAdmin(`practice-train/supervisor-evaluation-sheet`)
  }

  public static toProbation = (item: {
    roleType: number
    idMlnEmp: string
    idPracticalTraining: string
    mentorIdMlnEmp: string
  }) => {
    RouterUtil.toAdmin(
      `practice-train/probation-work-recoder${routeParams(item)}`
    )
  }

  // 指导人任务清单
  public static toTaskCardDetail = (idPracticalTraining: string) => {
    RouterUtil.toAdmin(
      `practice-train/task-list-detail?idPracticalTraining=${idPracticalTraining}`
    )
  }

  // 行动计划-学员反馈表
  public static toStudentFeedBackDetail = (idPracticalTraining: string) => {
    RouterUtil.toAdmin(
      `practice-train/student-feedback-form?idPracticalTraining=${idPracticalTraining}`
    )
  }
  // 行动计划-指导人评价表
  public static toMentorEvaluationForm = (
    idPracticalTraining: string,
    evaType: number
  ) => {
    RouterUtil.toAdmin(
      `practice-train/mentor-evaluation-form?idPracticalTraining=${idPracticalTraining}&evaType=${evaType}`
    )
  }

  // 知圈
  public static toTopticDetail = (
    history: RouteComponentProps['history'],
    topicId: string
  ) => history.push(`/home/topicDetail/${topicId}`)

  // 帖子
  public static toPostDetail = (
    history: RouteComponentProps['history'],
    postId: string
  ) => history.push(`/home/postDetail/${postId}`)

  // 培训项目
  public static toHumanTraining = (
    history: RouteComponentProps['history'],
    trainingItemId: string
  ) => history.push(`/home/humanTraining/${trainingItemId}`)

  // 作业
  public static toHomeWork = (
    history: RouteComponentProps['history'],
    id: string,
    score?: string,
    endTime?: string,
    homeWorkSource?: string
  ) =>
    history.push(
      `/home/homework/fromUser/${id}/${score}/${endTime}${
        homeWorkSource ? `/${homeWorkSource}` : ''
      }?needAuth=1`
    )

  // 培训项目
  public static toOpenTrainingProjectList = (
    history: RouteComponentProps['history']
  ) => history.push('/home/openTrainingProjectList')

  // 培训项目
  public static toOpenTrainingDetail = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/openTrainingDetail/?trainingItemId=${id}`)

  // 题库
  public static toExamLibraryDetail = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/home/examLibrary/`)

  // 培训项目
  public static toRankListDetail = (
    history: RouteComponentProps['history'],
    id: string
  ) => history.push(`/rankDetail/${id}`)
}
